import * as React from "react";

const IconStockAvailable: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 13"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path fill="#00A65A" d="M6 .5a6 6 0 100 12 6 6 0 100-12zm2.714 4.964l-3 3a.653.653 0 01-.928 0l-1.5-1.5a.657.657 0 01.929-.929L5.25 7.073l2.536-2.536a.657.657 0 01.928.928z"/></svg>;
};

export default React.memo(IconStockAvailable);
